module.exports = __webpack_public_path__ + "img/img05.69dcdff1.jpeg";